/**
 * reducers/contact.js
 */

const initialState = {
  result: undefined,
  error: false
}
export default (state = initialState,action) => {
  switch (action.type){
    case 'RECIVE_DATA':
      return action.payload.error 
        ? {...state,error:true}
        :{
          ...state,
          result:getResult(action.payload.response)
        }
      case 'SEND_SUCCESS':
        return {
          result:true,
          error:false
        }
      default:
        return state;
  }
}

const getResult = response => {
  console.log(response);
}


// WEBPACK FOOTER //
// ./src/reducers/contact.js